'use strict';

exports.__esModule = true;

var _class, _temp2;
/**
 * Выводим информацию о звонке.
 * 
 * На вход обязательно объект пользователя, которому звонок должен идти.
 * А так же передается конкретный звонок, если надо вывести информацию по нему
 * 
 * Это окно довольно сложную логику имеет, поэтому в случае необходимости
 * расширить его функционал, надо будете перенести в node_modules
 */
// import MiniModal from "ui/MiniModal";
// import SimpleSelect from "ui/SelectField/Simple";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import RequestCallButton from "ui/Button/User/RequestCall";
// import PayButton from "./PayButton";


var styles = {
  root: {
    color: "#666"
  },
  textDefault: {
    color: "#666",
    fontSize: "0.8rem"
  },
  textBig: {
    fontSize: "2rem",
    fontWeight: 600
  },
  textMiddle: {
    fontSize: "1.4rem",
    fontWeight: 600
  },
  header: {
    color: "white",
    padding: 10,
    textAlign: "center",
    fontSize: "1.2rem"
  },
  content: {
    padding: 15,
    minHeight: 300,
    maxHeight: 500,
    overflow: "auto"
  },
  centered: {
    textAlign: "center"
  },
  select: {
    marginTop: 15,
    marginBottom: 15 // "&.Select": {
    //   "& .Select-control": {
    //     "& .Select-value-label": {
    //       color: "red",
    //     }
    //   },
    // },

  },
  requestButton: {
    fontSize: "1rem",
    height: 40,
    lineHeight: "40px",
    borderRadius: 20,
    justifyContent: "center",
    width: "90%"
  }
};
var CallInfo = (_temp2 = _class = function (_Component) {
  _inherits(CallInfo, _Component);

  function CallInfo() {
    var _temp, _this, _ret;

    _classCallCheck(this, CallInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      durations: [{
        value: 15,
        label: "15 minutes"
      }, {
        value: 30,
        label: "30 minutes"
      }, {
        value: 45,
        label: "45 minutes"
      }, {
        value: 60,
        label: "1 hour"
      }, {
        value: 90,
        label: "1.5 hour"
      }, {
        value: 120,
        label: "2 hours"
      }],
      newCallDuration: 15
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CallInfo.prototype.render = function render() {
    var _props = this.props,
        classes = _props.classes,
        user = _props.user,
        room = _props.room;

    if (!user || !room) {
      return null;
    }

    var call = room.Call;
    var _state = this.state,
        durations = _state.durations,
        newCallDuration = _state.newCallDuration;
    var _context = this.context,
        currentUser = _context.user,
        acceptCall = _context.acceptCall,
        rejectCall = _context.rejectCall;

    if (!currentUser) {
      return null;
    }

    var currentUserId = currentUser.id,
        tokens = currentUser.tokens;
    var callPrice = user.callPrice;
    var minutePrice = callPrice ? (callPrice / 60).toFixed(2) : 0;
    var tokensBalance = tokens ? (Number(tokens) / Math.pow(10, 18)).toFixed(2) : 0;
    var header = minutePrice + "\u20AC per minute";
    var content = void 0;

    if (call) {
      /**
       * Если звонок есть, то зависит от его статуса.
       * Если статус еще незавершенный, то надо показать инфу
       */
      var callId = call.id,
          status = call.status,
          calledId = call.User.id,
          callerId = call.CreatedBy.id,
          _call$min_time = call.min_time,
          duration = _call$min_time === undefined ? 0 : _call$min_time;
      var _newCallDuration = duration;
      var amount = callPrice > 0 ? (callPrice / 60 * _newCallDuration).toFixed(2) : 0;
      var buttons = void 0;
      var info = void 0;

      if (calledId === currentUserId) {
        if (["Canceled", "Accepted", "Started"].indexOf(status) === -1) {
          buttons = _react2.default.createElement(_Grid2.default, {
            container: true
          }, _react2.default.createElement(_Grid2.default, {
            item: true,
            xs: 6
          }, _react2.default.createElement('button', {
            className: ["button bg-blue", classes.requestButton].join(" "),
            onClick: acceptCall,
            disabled: ["Accepted", "Started"].indexOf(status) !== -1
          }, 'Accept')), _react2.default.createElement(_Grid2.default, {
            item: true,
            xs: 6
          }, _react2.default.createElement('button', {
            className: ["button bg-grey", classes.requestButton].join(" "),
            onClick: rejectCall,
            disabled: status === "Rejected"
          }, 'Reject')));
        }
      } else {
        info = _react2.default.createElement('div', null, _react2.default.createElement('div', {
          className: classes.textDefault,
          style: {
            marginTop: 10,
            marginBottom: 15
          }
        }, 'Your balance ', _react2.default.createElement(_reactRouterDom.Link, {
          to: '/payments',
          className: "text-blue"
        }, 'Top-up'), ' ', _react2.default.createElement('br', null), tokensBalance, "\u20AC"), _react2.default.createElement('div', {
          className: classes.textDefault,
          style: {
            marginTop: 10
          }
        }, 'If the duration of call was less then stated, we will refund the difference to your balance. Minimum non-refundable duration is ', _newCallDuration, ' minutes.'));
      }

      var state = void 0;

      switch (status) {
        case "Requested":
          state = "Not accepted yet";
          break;

        default:
          state = status;
      }

      content = _react2.default.createElement('div', {
        className: classes.centered
      }, _react2.default.createElement('div', {
        style: {
          marginBottom: 15
        }
      }, _react2.default.createElement('p', {
        className: ["uppercase", classes.textDefault].join(" ")
      }, 'State'), _react2.default.createElement('p', {
        className: ["text-blue", classes.textMiddle].join(" ")
      }, state)), _react2.default.createElement('div', {
        style: {
          marginBottom: 15
        }
      }, _react2.default.createElement('p', {
        className: ["uppercase", classes.textDefault].join(" ")
      }, 'Duration'), _react2.default.createElement('p', {
        className: ["text-blue", classes.textMiddle].join(" ")
      }, duration, ' minutes')), _react2.default.createElement('div', {
        style: {
          marginBottom: 15
        }
      }, _react2.default.createElement(_Typography2.default, {
        className: ["uppercase", classes.textDefault].join(" ")
      }, 'Amount to pay'), _react2.default.createElement(_Typography2.default, {
        className: ["uppercase", classes.textDefault, classes.textBig].join(" ")
      }, amount, "\u20AC")), buttons, info);
    } else {
      /**
       * Если звонка нет, то выводим информацию для запроса звонка
       */
      var _amount = callPrice > 0 ? (callPrice / 60 * newCallDuration).toFixed(2) : 0;

      content = _react2.default.createElement('div', {
        className: classes.centered
      }, _react2.default.createElement(_Typography2.default, {
        className: ["uppercase", classes.textDefault].join(" ")
      }, 'Set the duration'), _react2.default.createElement(_Typography2.default, {
        className: ["uppercase", classes.textDefault].join(" ")
      }, 'Amount to pay'), _react2.default.createElement(_Typography2.default, {
        className: ["uppercase", classes.textDefault, classes.textBig].join(" ")
      }, _amount, "\u20AC"), _react2.default.createElement('div', {
        className: classes.textDefault,
        style: {
          marginTop: 10,
          marginBottom: 15
        }
      }, 'Your balance ', _react2.default.createElement(_reactRouterDom.Link, {
        to: '/payments',
        className: "text-blue"
      }, 'Top-up'), ' ', _react2.default.createElement('br', null), tokensBalance, "\u20AC"), _react2.default.createElement('div', {
        className: classes.textDefault,
        style: {
          marginTop: 10
        }
      }, 'If the duration of call was less then stated, we will refund the difference to your balance. Minimum non-refundable duration is ', newCallDuration, ' minutes.'));
    }

    return _react2.default.createElement('div', {
      style: {
        position: "relative"
      }
    }, _react2.default.createElement('div', {
      className: [classes.header, "bg-grey"].join(" ")
    }, header), _react2.default.createElement('div', {
      className: classes.content
    }, content));
  };

  return CallInfo;
}(_react.Component), _class.contextTypes = {
  user: _propTypes2.default.object.isRequired,
  acceptCall: _propTypes2.default.func.isRequired,
  rejectCall: _propTypes2.default.func.isRequired
}, _temp2);
CallInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  room: _propTypes2.default.object
} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(CallInfo, props);
});
module.exports = exports['default'];